import React, { Fragment } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import styles from './styles.styl';
import { PROVIDER_OPTION } from '../../../constants';
import Icon from '../../../../../Icon';

const { NAME_ID, ICON } = PROVIDER_OPTION;

const MeasurementTitles = ({
  data,
  mark,
  dates,
  sources,
  loading,
  formats,
  nothing,
  config,
  converter,
  activeSource,
  intl: { formatMessage },
}) => {
  const lastElem = data.length - 1;
  const { resources } = config.data.customOptions.providers[sources[0]] || {};
  const showConverterLabel = Boolean(data.length > 0 && converter.label);

  return (
    <div className={styles.container}>
      {nothing ? (
        <h2>-</h2>
      ) : (
        <div className={styles.groups}>
          {data.map(([nameId, points], i) => {
            const { [NAME_ID]: resourceNameId, [ICON]: iconName } = resources[
              nameId
            ];

            return (
              <div className={styles.item} key={nameId}>
                <div>
                  {iconName && (
                    <Icon size={24} className="mr2" name={iconName} />
                  )}
                  {resourceNameId && formatMessage({ id: resourceNameId })}
                </div>
                <h2>
                  {converter.func([points])}
                  {i === lastElem && <span> {mark}</span>}
                </h2>
              </div>
            );
          })}
        </div>
      )}
      <div className={cn(styles.sub, styles.dates)}>
        {!loading ? (
          <Fragment>
            {showConverterLabel && (
              <span className={styles.label}>{converter.label}</span>
            )}
            {dates.join(' - ')}
          </Fragment>
        ) : (
          '-'
        )}
      </div>

      <div className={styles.sub}>
        {!activeSource ? formats.all : formats[activeSource]}
      </div>
    </div>
  );
};

MeasurementTitles.propTypes = {
  data: PropTypes.array,
  mark: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  dates: PropTypes.array,
  nothing: PropTypes.bool,
  loading: PropTypes.bool,
  sources: PropTypes.array,
  config: PropTypes.object,
  formats: PropTypes.object,
  converter: PropTypes.object,
  activeSource: PropTypes.string,
  intl: PropTypes.object.isRequired,
};

export default injectIntl(MeasurementTitles);



// WEBPACK FOOTER //
// ./src/components/common/Charts/ChartWrapper/ChartHeader/MeasurementTitles/index.jsx